module.exports = __webpack_public_path__ + "static/Tagline-SVG-efb5e298c4afd936c17c64d00dc540e0.svg";